export enum LogLevelName {
  NoConsoleInputLog = "noConsoleInputLog",
}
